import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Styles from "./requestTracking.module.css";
import { MdDelete } from "react-icons/md";
import { httpNonToken, endPoints } from "../../globalConf/http-non-token";
import { http, endPointsToken } from "../../globalConf/http";
import CustomToastify, { toastMes } from "../../globalConf/notification";
import Loading from "./../loading/loading";
import { Link } from "react-router-dom";
import moment from "moment";
import Style from "./requestTracking.module.css";
import { Modal, Backdrop, Fade, Typography, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import ModelStatus from "./modelStatus";
import DatePicker from "react-datepicker";
import TableToExcel from "@linways/table-to-excel";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import axios from "axios";

const RequestTracking = ({ home = false }) => {
  const [load, setLoad] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [allRequestStatus, setAllRequestStatus] = useState([]);
  const [allRequestStatus360, setAllRequestStatus360] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [allRequestService, setAllRequestService] = useState([]);
  const [date, setDate] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(home ? 5 : 20);
  const [success, setSuccess] = useState(false);
  const [flag, setFlag] = useState(false);
  const [patientPhone, setPatientPhone] = useState("");
  const [patientName, setPatientName] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [selectedRequestId, setSelectedRequestId] = useState("");
  const [requestId, setRequestId] = useState("");
  const [checkedState, setCheckedState] = useState([]);
  const [open, setOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedRequestPayment, setSelectedRequestPayment] = useState(null);
  const [newPrice, setNewPrice] = useState(0);
  const [newDiscount, setNewDiscount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [partialPaid, setPartialPaid] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  //   const [currentRequestId, setCurrentRequestId] = useState(null);

  // const fileInputRef = useRef(null);

  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const fileInputRefs = useRef({});
  //
  const [statusFlag, setStatusFlag] = useState(false);
  const [statusId, setStatusId] = useState();
  const [request, setRequest] = useState({});
  //
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [aiRequests, setAiRequests] = useState([]);

  const formatStatusName = (name) => {
    if (!name) return "";
    if (name === "Delivered to Patient") return "Completed";
    if (name === "In progress") return "Processing";
    return name;
  };

  const { user } = useSelector((state) => state.login);
  let data = JSON.parse(localStorage.getItem("userOP"));
  const navigate = useNavigate();

  const fetchAiRequests = async (currentPage = 1, limit = 10) => {
    try {
      const response = await axios.get(
        `https://py.qubx3d.com/api/v1/ai-segmentation/requests/?page=${currentPage}&page_size=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${data.access}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching AI requests:", error);
      return { results: [], count: 0, total_pages: 0 };
    }
  };

  const fetchData = async () => {
    return new Promise(async (resolve, reject) => {
      if (data) {
        try {
          let res;
          try {
            res = await httpNonToken.get(
              `${endPoints.request}?order_by=-created_at${
                requestId ? `&id=${requestId}` : ""
              }&page=${page}${
                selectedStatus ? `&statu__id=${selectedStatus}` : ""
              }${date ? `&created_at__date=${date}` : ""}${
                selectedBranch
                  ? `&created_by__branch_profile__id=${selectedBranch}`
                  : ""
              }${selectedService ? `&service__type__id=${selectedService}` : ""}${
                patientName
                  ? `&patient__fullname__icontains=${patientName}`
                  : ""
              }${doctorName ? `&doctor__fullname__icontains=${doctorName}` : ""}${
                startDate
                  ? `&created_at__date__gte=${
                      new Date(startDate).toISOString().split("T")[0]
                    }`
                  : ""
              }${
                endDate
                  ? `&created_at__date__lte=${
                      new Date(endDate).toISOString().split("T")[0]
                    }`
                  : ""
              }&page_size=${pageSize}${
                patientPhone ? `&patient__mobile__contains=${patientPhone}` : ""
              }`,
              {
                headers: {
                  Authorization: `Bearer ${data.access}`,
                },
              },
            );
          } catch (e) {
            if (e?.response?.status === 404) {
              const fallbackRes = await httpNonToken.get(
                `${endPoints.request}?order_by=-created_at&page=1&page_size=${pageSize}`,
                { headers: { Authorization: `Bearer ${data.access}` } },
              );
              res = {
                data: { count: fallbackRes.data.count || 0, results: [] },
              };
            } else {
              throw e;
            }
          }

          resolve(res.data);
          const resStatus360 = await httpNonToken.get(
            `${endPoints.status360}?order_by=id`,
          );
          const resStatus = await httpNonToken.get(
            `${endPoints.requestStatus}?order_by=id`,
          );

          const branchedRes = await httpNonToken.get(
            `${endPoints.rcBranch}?order_by=id&page_size=1000`,
          );
          const resService = await httpNonToken.get(
            `${endPoints.serviceType}?order_by=id`,
          );

          // Fetch AI requests using backend pagination
          const aiResponseData = await fetchAiRequests(page, pageSize);
          const aiRawResults = Array.isArray(aiResponseData)
            ? aiResponseData
            : aiResponseData.results || [];

          // Transform AI requests to match the structure of regular requests
          const transformedAiRequests = aiRawResults
            .filter((aiReq) => aiReq && typeof aiReq === "object")
            .map((aiReq) => {
              const aiStatusMapping = {
                pending_payment: { id: 3, name: "Pending Payment" },
                processing: { id: 5, name: "Processing" },
                completed: { id: 13, name: "Completed" },
                failed: { id: 4, name: "Failed" },
                waiting_upload: { id: 2, name: "Waiting for Upload" },
              };
              const mappedStatus = aiStatusMapping[aiReq.status] || {
                id: 0,
                name:
                  aiReq.status_display ||
                  aiReq.status_name ||
                  aiReq.status ||
                  "AI Request",
              };
              return {
                ...aiReq,
                id: `AI-${aiReq.id || Math.random()}`,
                isAiRequest: true,
                statu: { ...mappedStatus, SLA: 0 },
                patient: {
                  fullname:
                    aiReq.patient_name ||
                    aiReq.patient?.fullname ||
                    "AI Patient",
                  mobile: aiReq.patient_phone || aiReq.patient?.mobile || "",
                },
                doctor: {
                  fullname:
                    aiReq.doctor_name || aiReq.doctor?.fullname || "AI Doctor",
                },
                branchName:
                  aiReq.branch_name || aiReq.branch?.name || "AI Branch",
                service: { name: "AI Segmentation", type: { id: 4 } },
                created_at: aiReq.created_at || new Date().toISOString(),
                note: false,
                updatedAtStatus:
                  aiReq.updated_at ||
                  aiReq.created_at ||
                  new Date().toISOString(),
              };
            });

          // Frontend filtering on current page (fallback since AI backend does not support all params yet)
          let filteredAiRequests = transformedAiRequests;
          if (selectedService && parseInt(selectedService) !== 4)
            filteredAiRequests = [];
          if (selectedBranch && filteredAiRequests.length > 0) {
            const selectedBranchObj = branchedRes.data.results.find(
              (b) => b.id === parseInt(selectedBranch),
            );
            const selectedBranchName = selectedBranchObj?.name || "";
            filteredAiRequests = filteredAiRequests.filter((req) =>
              req.branchName
                ?.toLowerCase()
                .includes(selectedBranchName.toLowerCase()),
            );
          }
          if (selectedStatus && filteredAiRequests.length > 0) {
            filteredAiRequests = filteredAiRequests.filter(
              (req) => req.statu.id === parseInt(selectedStatus),
            );
          }
          if (patientName && filteredAiRequests.length > 0) {
            filteredAiRequests = filteredAiRequests.filter((req) =>
              req.patient.fullname
                .toLowerCase()
                .includes(patientName.toLowerCase()),
            );
          }
          if (doctorName && filteredAiRequests.length > 0) {
            filteredAiRequests = filteredAiRequests.filter((req) =>
              req.doctor?.fullname
                .toLowerCase()
                .includes(doctorName.toLowerCase()),
            );
          }
          if (requestId && filteredAiRequests.length > 0) {
            filteredAiRequests = filteredAiRequests.filter((req) =>
              req.id.toString().toLowerCase().includes(requestId.toLowerCase()),
            );
          }
          if (startDate && filteredAiRequests.length > 0) {
            const start = new Date(startDate);
            start.setHours(0, 0, 0, 0);
            filteredAiRequests = filteredAiRequests.filter(
              (req) => new Date(req.created_at) >= start,
            );
          }
          if (endDate && filteredAiRequests.length > 0) {
            const end = new Date(endDate);
            end.setHours(23, 59, 59, 999);
            filteredAiRequests = filteredAiRequests.filter(
              (req) => new Date(req.created_at) <= end,
            );
          }

          // Combine regular requests with evaluated AI paginated requests
          const combinedResults = [
            ...(res.data.results || []),
            ...filteredAiRequests,
          ];

          // Sort combined results by date descending locally for the current page grouping
          combinedResults.sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();
            return dateB - dateA;
          });

          // Unify standard count & pagination indicators
          const combinedCount =
            (res.data.count || 0) + (aiResponseData.count || 0);
          const maxPages = Math.max(
            res.data.total_pages || 0,
            aiResponseData.total_pages || 0,
          );

          const combinedData = {
            ...res.data,
            results: combinedResults,
            count: combinedCount,
            total_pages: maxPages,
            next: page < maxPages ? "has_next" : null,
            previous: page > 1 ? "has_prev" : null,
            page_number: page,
          };

          setDataTable(combinedData);
          setAiRequests(transformedAiRequests);

          let sketchfabArr = [...checkedState];
          for (let i = 0; i < res.data.results.length; i++) {
            sketchfabArr.push(res.data.results[i].sketchfab);
          }

          setAllRequestStatus360(resStatus360.data);
          setCheckedState(sketchfabArr);
          setAllRequestStatus(resStatus.data.results);
          setAllRequestService(resService.data.results);
          setAllBranches(branchedRes.data.results);
          setLoad(false);
        } catch ({ response }) {
          if (response.status === 401 && response.data.code) {
            localStorage.removeItem("userOP");
            navigate("/login");
            return;
          }
        }
      } else {
        navigate("/login");
      }
    });
  };
  useEffect(() => {
    if (data) {
      fetchData();
    } else {
      navigate("/login");
    }
  }, [
    selectedStatus,
    selectedBranch,
    selectedService,
    startDate,
    endDate,
    page,
    date,
    pageSize,
    patientName,
    doctorName,
    requestId,
    flag,
  ]);

  const clearAllFilter = () => {
    setSelectedStatus("");
    setSelectedService("");
    setPatientName("");
    setDoctorName("");
    setRequestId("");
    setDate(null);
    setStartDate(null);
    setEndDate(null);
    setSelectedBranch("");
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const handlePaymentOpen = (req) => {
    setSelectedRequestPayment(req);
    setNewPrice(req.price || 0);
    setNewDiscount(req.special_discount || 0);
    setPaidAmount(0);
    setPartialPaid(req.partial_paid || false);
    setIsPaid(req.is_paid || false);
    setPaymentModalOpen(true);
  };

  const handlePaymentClose = () => {
    setPaymentModalOpen(false);
    setSelectedRequestPayment(null);
  };

  const handlePaymentUpdate = async () => {
    try {
      if (
        selectedRequestPayment.isAiRequest ||
        (Number(newPrice) === Number(selectedRequestPayment.price || 0) &&
          Number(newDiscount) ===
            Number(selectedRequestPayment.special_discount || 0))
      ) {
        toastMes.success("Payment information updated successfully");
        handlePaymentClose();
        return;
      }
      const updateData = {
        price: newPrice,
        special_discount: newDiscount,
      };
      await axios.patch(
        `https://py.qubx3d.com/api/v2/requests/${selectedRequestPayment.id}/update-price-discount`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${data.access}`,
          },
        },
      );
      toastMes.success("Payment information updated successfully");
      setFlag(!flag);
      handlePaymentClose();
    } catch (err) {
      toastMes.error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update payment",
      );
    }
  };

  const handlePartialPaymentUpdate = async () => {
    try {
      const originalId = selectedRequestPayment.id
        .toString()
        .replace("AI-", "");
      const updateData = {
        amount: parseFloat(paidAmount),
      };
      await axios.patch(
        `https://py.qubx3d.com/api/v2/requests/${originalId}/update-partial-payment/`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${data.access}`,
          },
        },
      );
      toastMes.success("Partial payment updated successfully");
      setFlag(!flag);
      handlePaymentClose();
    } catch (err) {
      toastMes.error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update partial payment",
      );
    }
  };

  const handleTogglePaid = async () => {
    try {
      if (selectedRequestPayment.isAiRequest) {
        const originalId = selectedRequestPayment.id
          .toString()
          .replace("AI-", "");
        await axios.post(
          `https://py.qubx3d.com/api/v1/ai-segmentation/requests/${originalId}/mark-paid/`,
          {},
          {
            headers: {
              Authorization: `Bearer ${data.access}`,
            },
          },
        );
      } else {
        await axios.patch(
          `https://py.qubx3d.com/api/v2/requests/${selectedRequestPayment.id}/toggle-paid/`,
          {},
          {
            headers: {
              Authorization: `Bearer ${data.access}`,
            },
          },
        );
      }
      setIsPaid(!isPaid);
      toastMes.success("Payment status updated successfully");
      setFlag(!flag);
    } catch (err) {
      toastMes.error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to update payment status",
      );
    }
  };

  const downloadInvoice = (id) => {
    const originalId = id.toString().replace("AI-", "");
    window.open(`/invoice/${originalId}`, "_blank");
  };

  const getRequestsByPhone = async (e) => {
    setPatientPhone(e.target.value);
    try {
      const res = await httpNonToken.get(
        `${endPoints.request}?page=${page}${
          selectedStatus ? `&statu__id=${selectedStatus}` : ""
        }${date ? `&created_at__date=${date}` : ""}&page_size=${pageSize}${
          patientPhone ? `&patient__mobile__contains=${patientPhone}` : ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${data.access}`,
          },
        },
      );

      setDataTable(res.data);
    } catch ({ response }) {
      setSuccess(false);
      toastMes.error(response.data.message);
    }
  };

  const handleChange = async (event, id, position = 0) => {
    event.stopPropagation();
    event.preventDefault();
    let data = {};
    if (event.target.name === "cloud") {
      const updatedCheckedState = checkedState.map((item, index) => {
        if (index === position) data.sketchfab = !item;
        return index === position ? !item : item;
      });

      setCheckedState(updatedCheckedState);
    } else if (event.target.name === "status") {
      data.statu = event.target.value;
    }
    try {
      await httpNonToken.put(`${endPoints.updateRequest}/${id}`, data);
      setFlag(!flag);
      setSuccess(true);
      toastMes.success("Request Updates Successfully");
    } catch ({ response }) {
      setFlag(!flag);
      setSuccess(false);
      toastMes.error(response.data.message);
    }
  };

  const getTodayRequests = () => {
    let today = moment(new Date()).format("YYYY-MM-DD");
    setDate(today);
  };

  if (load) {
    return <Loading />;
  }

  const handlePageChange = (pageNum) => {
    setPage(pageNum);
  };

  const handleOpenDeleteModel = async (id) => {
    setSelectedRequestId(id);
    handleOpen();
  };

  const handleSubmit = async (e) => {
    try {
      await http.delete(`${endPointsToken.deleteRequest}/${selectedRequestId}`);
      toastMes.success("Request Deleted Successfully");
      setFlag(!flag);
      handleClose();
    } catch ({ response }) {
      toastMes.error(response.data.message[0]);
    }
  };

  const getStyle = (id) => {
    let style = {};
    style.borderRadius = "0px";
    style.textAlign = "center";
    style.padding = "5px";
    if (id === 2) {
      style.backgroundColor = "#FE9F44";
    } else if (id === 4) {
      style.backgroundColor = "#Ff4b4b";
    } else if (id === 5) {
      style.backgroundColor = "#77c3f6";
    } else if (id === 10) {
      style.backgroundColor = "#86b4b5";
    } else if (id === 11) {
      style.backgroundColor = "#F8a4a4";
    } else if (id === 12) {
      style.backgroundColor = "#D6e3a0";
    } else if (id === 13) {
      style.backgroundColor = "#A6efb5";
    } else if (id === 3) {
      style.backgroundColor = "#Feff6b";
    } else if (id === 6) {
      style.backgroundColor = "#Cbb1c7";
    } else if (id === 7) {
      style.backgroundColor = "#D5a4ff";
    } else if (id === 8) {
      style.backgroundColor = "#Cae3ff";
    } else if (id === 9) {
      style.backgroundColor = "#559b85";
    } else if (id === 14) {
      style.backgroundColor = "#E6e6e6";
    } else {
      style.backgroundColor = "lightgrey";
    }
    return style;
  };

  const actionChange = async (req) => {
    // Skip action for AI requests
    if (req.isAiRequest) {
      return;
    }

    if (req.statu && req.statu.id === 3) {
      try {
        let reqData = {};
        reqData.statu = 5;
        reqData.assign_to = data.user.id;
        await httpNonToken.put(`${endPoints.updateRequest}/${req.id}`, reqData);

        setSuccess(true);
        setFlag(!flag);
        toastMes.success("Request Updates Successfully.");
      } catch ({ response }) {
        setFlag(!flag);
        setSuccess(false);
        toastMes.error(response.data.message);
      }
    } else if (req.statu && req.statu.id === 5) {
      setStatusId(req.statu.id);
      setStatusFlag(true);
      setRequest(req);
    } else if (req.statu && req.statu.id === 8) {
      try {
        const updateReq = await httpNonToken.put(
          `${endPoints.updateRequest}/${req.id}`,
          {
            quality_assurence: true,
          },
        );
        if (updateReq.status === 200) {
          setFlag(!flag);
          toastMes.success("Request Updates Successfully");
        }
      } catch ({ response }) {
        toastMes.error(response.data.message);
      }
    } else if (req.statu && req.statu.id === 6) {
      setStatusId(req.statu.id);
      setStatusFlag(true);
      setRequest(req);
    } else if (req.statu && req.statu.id === 9) {
      setStatusId(req.statu.id);
      setStatusFlag(true);
      setRequest(req);
    } else if (req.statu && req.statu.id === 11) {
      try {
        await httpNonToken.put(`${endPoints.updateRequest}/${req.id}`, {
          statu: 12,
        });

        setFlag(!flag);
        toastMes.success("Request Updates Successfully.");
      } catch ({ response }) {
        toastMes.error(response.data.message);
      }
    }
  };

  const ToExcell = () => {
    TableToExcel.convert(document.getElementById("table-data"), {
      name: "Qubx-Requests.xlsx",
      sheet: {
        name: "Sheet 1",
      },
    });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const handleChunkedUpload = async (event, requestId) => {
    const file = event.target.files[0];
    if (!file) return;

    const CHUNK_SIZE = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const uploadId = `${Date.now()}-${Math.random()
      .toString(36)
      .substring(2, 9)}`;
    const targetField = "DICOM_3D_File";

    setIsUploading(true);
    setProgress(0);
    setError(null);

    try {
      for (let i = 0; i < totalChunks; i++) {
        const start = i * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("chunk", chunk, file.name);
        formData.append("chunk_index", String(i));
        formData.append("total_chunks", String(totalChunks));
        formData.append("filename", file.name);
        formData.append("upload_id", uploadId);
        formData.append("target_field", targetField);

        await axios.post(
          `https://py.qubx3d.com/api/v2/requests/${requestId}/chunked-upload/`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (ev) => {
              const chunkLoaded = ev.loaded || 0;
              const uploadedSoFar = i * CHUNK_SIZE + chunkLoaded;
              const percent = Math.min(
                100,
                Math.floor((uploadedSoFar / file.size) * 100),
              );
              setProgress(percent);
            },
          },
        );
      }
      await axios.put(
        `https://py.qubx3d.com/api/v1/request/update/${requestId}`,
        { quality_assurence: true },
      );
      toastMes.success("File uploaded successfully");
      setFlag((prev) => !prev);
    } catch (err) {
      console.error(err);
      setError(err.message || "Upload failed");
      toastMes.error("Upload failed");
    } finally {
      setIsUploading(false);
      setProgress(100);
    }
  };

  return (
    <div className={`${home ? "" : "bg_light p-2 h-100"}`}>
      <div className="bg-white border m-4 table-content request-track-table">
        <div className="align-items-center pt-3 mb-2">
          <div className="row">
            <div className=" col-md-2 filters-label">
              <div className="mx-2" style={{ marginTop: "24px" }}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={clearAllFilter}
                >
                  Clear Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="row px-2">
            {/* <div className="col-md-2">
              <TextField
                fullWidth
                id="outlined-basic"
                label="Search By Phone Number .."
                variant="outlined"
                size="small"
                value={patientPhone}
                onChange={(e) => getRequestsByPhone(e)}
                className="float-start mt-4 me-3"
              />
            </div> */}
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="Search By Patient Name .."
                variant="outlined"
                size="small"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                className="float-start mt-4 me-3"
              />
            </div>

            {home ? null : (
              <div className="searchDate col-md-5 mt-4">
                <div className="date-range d-flex align-items-center">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Start date"
                    className="form-control"
                    dateFormat="dd MMM yyyy"
                  />
                  <i className="fa-solid fa-angle-right text-secondary mx-2"></i>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    placeholderText="End date"
                    className="form-control"
                    dateFormat="dd MMM yyyy"
                  />
                </div>
              </div>
            )}
            <div className="col-md-2 mt-4">
              <Box sx={{ minWidth: 200 }}>
                <FormControl className={`w-100`}>
                  <InputLabel
                    id="demo-simple-select-label"
                    className={Styles.label_margin}
                  >
                    Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    value={selectedStatus}
                    className={`${Styles.h_status}`}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  >
                    {allRequestStatus.map((status, index) => (
                      <MenuItem key={index} value={status.id}>
                        {formatStatusName(status.name)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div className="col-md-2 mt-4">
              <Box sx={{ minWidth: 200 }}>
                <FormControl className={`w-100`}>
                  <InputLabel
                    id="demo-simple-select-label"
                    className={Styles.label_margin}
                  >
                    Service
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    value={selectedService}
                    className={`${Styles.h_status}`}
                    onChange={(e) => setSelectedService(e.target.value)}
                  >
                    {allRequestService.map((service, index) => (
                      <MenuItem key={index} value={service.id}>
                        {service.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="Search By ID .."
                variant="outlined"
                size="small"
                value={requestId}
                onChange={(e) => setRequestId(e.target.value)}
                className="float-start mt-4 me-3"
              />
            </div>
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-basic"
                label="Search By Doctor Name"
                variant="outlined"
                size="small"
                value={doctorName}
                onChange={(e) => setDoctorName(e.target.value)}
                className="float-start mt-4 me-3"
              />
            </div>
            {/* <div className="searchDate float-start mt-4">
              <input
                type="date"
                id="searchDate"
                className="form-control"
                onChange={(e) => setDate(e.target.value)}
                value={date}
              />
            </div> */}
          </div>
          <div className="row px-4">
            <div
              className={`col-sm-2 mt-4 mx-1 py-1 text-center filters ${Style.filter_today} text-bold cursor-pointer`}
              onClick={getTodayRequests}
            >
              {date ? <i className="fa-solid fa-check mx-2"></i> : ""} Today
            </div>
            <div
              className={`col-sm-2 mt-4 mx-1 py-1 text-center filters ${Style.filter_pending} text-bold cursor-pointer`}
              onClick={() => setSelectedStatus(2)}
            >
              {selectedStatus === 2 ? (
                <i className="fa-solid fa-check mx-2"></i>
              ) : (
                ""
              )}
              Pending
            </div>
            <div
              className={`col-sm-2 mt-4 mx-1 py-1 text-center filters ${Style.filter_ready} text-bold cursor-pointer`}
              onClick={() => setSelectedStatus(3)}
            >
              {selectedStatus === 3 ? (
                <i className="fa-solid fa-check mx-2"></i>
              ) : (
                ""
              )}
              Ready
            </div>
            <div
              className={`col-sm-2 mt-4 mx-1 py-1 text-center filters ${Style.filter_returned} text-bold cursor-pointer`}
              onClick={() => setSelectedStatus(4)}
            >
              {selectedStatus === 4 ? (
                <i className="fa-solid fa-check mx-2"></i>
              ) : (
                ""
              )}
              Returned
            </div>
            <div
              className={`col-sm-2 mt-4 mx-1 py-1 text-center filters ${Style.filter_shipping} text-bold cursor-pointer`}
              onClick={() => setSelectedStatus(10)}
            >
              {selectedStatus === 10 ? (
                <i className="fa-solid fa-check mx-2"></i>
              ) : (
                ""
              )}
              Shipping Courier
            </div>
          </div>
        </div>
        <TableContainer sx={{ marginTop: 4 }} className="request-table-content">
          <div className="d-flex justify-content-end m-2 text-success cursor-pointer">
            <i onClick={ToExcell} className="fa-solid fa-file-excel fa-2x"></i>
          </div>
          <Table
            id="table-data"
            sx={{ minWidth: 650 }}
            aria-label="simple table"
          >
            <TableHead
              sx={{ backgroundColor: "#dbdce0", paddingRight: "17px" }}
            >
              <TableRow>
                <TableCell style={{ padding: "6px 16px" }}>ID</TableCell>
                <TableCell style={{ padding: "6px 16px" }}>Date</TableCell>
                <TableCell
                  style={{
                    position: "relative",
                    padding: "4px 16px",
                    cursor: "pointer",
                  }}
                >
                  <Box sx={{ minWidth: 120, border: 0 }}>Branch Name</Box>
                  <FormControl
                    sx={{ m: 1, minWidth: 120 }}
                    style={{
                      position: "absolute",
                      left: "-10px",
                      top: "-10px",
                    }}
                    size="small"
                  >
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      value={selectedBranch}
                      label="Status"
                      name="status"
                      onChange={(e) => setSelectedBranch(e.target.value)}
                    >
                      {allBranches.map((branch, index) => (
                        <MenuItem key={index} value={branch.id}>
                          {branch.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell style={{ padding: "6px 16px" }}>
                  Patient Name
                </TableCell>
                <TableCell style={{ padding: "6px 16px" }}>
                  Doctor Name
                </TableCell>
                <TableCell style={{ padding: "6px 16px" }}>Service</TableCell>
                <TableCell style={{ padding: "6px 16px" }}>
                  Status Edit
                </TableCell>
                <TableCell style={{ padding: "6px 16px" }}>Status</TableCell>
                <TableCell style={{ padding: "6px 16px" }}>Upload</TableCell>
                <TableCell style={{ padding: "6px 16px" }}>Flags</TableCell>
                <TableCell style={{ padding: "6px 16px" }}>
                  Invoice/Payment
                </TableCell>
                {data.user.groups.includes(2) ? (
                  <TableCell style={{ padding: "6px 16px" }}>Action</TableCell>
                ) : (
                  ""
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataTable.results.length > 0 ? (
                dataTable.results.map((req, index) => (
                  <TableRow key={req.id}>
                    <TableCell style={{ padding: "4px 16px" }}>
                      <Link
                        to={
                          req.isAiRequest
                            ? `/request_ai/${req.id}`
                            : req.service.type.id === 2
                              ? `/request_3D/${req.id}`
                              : req.service.type.id === 3
                                ? `/request_360/${req.id}`
                                : ""
                        }
                      >
                        {req.id}
                      </Link>
                    </TableCell>
                    <TableCell style={{ padding: "4px 16px" }}>
                      {new Date(req.created_at).toLocaleString()}
                    </TableCell>
                    <TableCell style={{ padding: "4px 16px" }}>
                      {req.branchName}
                    </TableCell>
                    <TableCell style={{ padding: "4px 16px" }}>
                      {req.patient.fullname}
                    </TableCell>
                    <TableCell style={{ padding: "4px 16px" }}>
                      {req.doctor?.fullname}
                    </TableCell>
                    <TableCell style={{ padding: "4px 16px" }}>
                      {req.isAiRequest ? (
                        <span style={{ color: "#007bff", fontWeight: "bold" }}>
                          AI Segmentation
                        </span>
                      ) : req.service.type.id === 2 ? (
                        <>
                          <img
                            width="50px"
                            alt="service card"
                            className="mx-2"
                            src={"/images/global/3d-printing.svg"}
                          />
                          <span>{req.service.name}</span>
                        </>
                      ) : (
                        <>
                          <img
                            width="50px"
                            alt="service card"
                            className="mx-2"
                            src={"/images/global/360-printing.svg"}
                          />
                          {req.service.name}
                        </>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        position: "relative",
                        padding: "4px 16px",
                        cursor: req.isAiRequest ? "not-allowed" : "pointer",
                        opacity: req.isAiRequest ? 0.6 : 1,
                      }}
                    >
                      <FormControl
                        sx={{ m: 1, minWidth: 120 }}
                        style={{
                          position: "absolute",
                          top: "5px",
                          left: "15px",
                        }}
                        size="small"
                      >
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={req.statu.id}
                          label="Status"
                          name="status"
                          disabled={req.isAiRequest}
                          onChange={(e) => handleChange(e, req.id)}
                        >
                          {req.isAiRequest ? (
                            <MenuItem value={req.statu.id}>
                              {formatStatusName(req.statu.name)}
                            </MenuItem>
                          ) : req.service.type.id === 2 ? (
                            allRequestStatus.map((status, index) => (
                              <MenuItem key={index} value={status.id}>
                                {formatStatusName(status.name)}
                              </MenuItem>
                            ))
                          ) : (
                            allRequestStatus360.map((status, index) => (
                              <MenuItem key={index} value={status.id}>
                                {formatStatusName(status.name)}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell
                      onClick={() =>
                        req.isAiRequest ? null : actionChange(req)
                      }
                      style={{
                        position: "relative",
                        padding: "4px 16px",
                        cursor: req.isAiRequest ? "not-allowed" : "pointer",
                        opacity: req.isAiRequest ? 0.5 : 1,
                      }}
                    >
                      <Box
                        style={getStyle(req.statu?.id)}
                        sx={{ minWidth: 120, border: 0 }}
                      >
                        {formatStatusName(req.statu?.name)}
                      </Box>
                    </TableCell>
                    <TableCell
                      style={{ padding: "4px 16px", textAlign: "center" }}
                    >
                      <input
                        type="file"
                        ref={(el) => (fileInputRefs.current[req.id] = el)}
                        style={{ display: "none" }}
                        onChange={(e) => handleChunkedUpload(e, req.id)}
                      />
                      {req.statu.name === "Quality Assurance" ? (
                        <button
                          onClick={() => fileInputRefs.current[req.id].click()}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          title="Upload"
                          disabled={isUploading}
                        >
                          {isUploading ? (
                            <span>
                              {" "}
                              {progress < 100
                                ? `Uploading ${progress}%`
                                : "Done"}
                            </span>
                          ) : (
                            <i
                              className="fa fa-upload fa-lg"
                              style={{ color: "#dbdce0" }}
                              aria-hidden="true"
                            ></i>
                          )}
                        </button>
                      ) : null}

                      {error && (
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {error}
                        </div>
                      )}
                    </TableCell>

                    <TableCell style={{ padding: "5px" }}>
                      {req.isAiRequest ? (
                        <div
                          className="d-flex justify-content-between"
                          style={{ opacity: 0.6 }}
                        >
                          <img
                            src={
                              req.note
                                ? "/images/requestTracking/note_activated.svg"
                                : "/images/requestTracking/note_deactivated.svg"
                            }
                            alt="img"
                            className="mx-1 d-block"
                          />
                          <img
                            src={
                              req.statu?.SLA !== 0 &&
                              moment(req.updatedAtStatus)
                                .add(req.statu?.SLA, "hours")
                                .isBefore(new Date())
                                ? "/images/requestTracking/delay_activated.svg"
                                : "/images/requestTracking/delay_deactivated.svg"
                            }
                            alt="img"
                            className="mx-1 d-block"
                          />
                        </div>
                      ) : (
                        <div className="d-flex justify-content-between">
                          <img
                            src={
                              req.note
                                ? "/images/requestTracking/note_activated.svg"
                                : "/images/requestTracking/note_deactivated.svg"
                            }
                            alt="img"
                            className="mx-1 d-block"
                          />
                          <img
                            src={
                              req.statu.SLA !== 0 &&
                              moment(req.updatedAtStatus)
                                .add(req.statu.SLA, "hours")
                                .isBefore(new Date())
                                ? "/images/requestTracking/delay_activated.svg"
                                : "/images/requestTracking/delay_deactivated.svg"
                            }
                            alt="img"
                            className="mx-1 d-block"
                          />
                        </div>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "4px 16px",
                        opacity: req.isAiRequest ? 0.9 : 1,
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <Tooltip title="Edit Invoice/Prices">
                          <i
                            className="fas fa-file-invoice-dollar fs-4 cursor-pointer mx-1 text-primary"
                            onClick={() => handlePaymentOpen(req)}
                          ></i>
                        </Tooltip>
                        <Tooltip
                          title={
                            req.is_paid
                              ? "Full Paid"
                              : req.partial_paid
                                ? "Partial Paid"
                                : "Unpaid"
                          }
                        >
                          <img
                            src={
                              req.is_paid
                                ? "/images/requestTracking/Paid.png"
                                : req.partial_paid
                                  ? "/images/requestTracking/Partial Paid.png"
                                  : "/images/requestTracking/Unpaid.png"
                            }
                            alt="payment status"
                            width="25px"
                            className="mx-1"
                          />
                        </Tooltip>
                      </div>
                    </TableCell>
                    {data.user.groups.includes(2) ? (
                      <TableCell sx={{ padding: "2px 14px" }}>
                        <Button
                          disabled={req.isAiRequest}
                          style={{ opacity: req.isAiRequest ? 0.6 : 1 }}
                        >
                          <MdDelete
                            onClick={() =>
                              req.isAiRequest
                                ? null
                                : handleOpenDeleteModel(req.id)
                            }
                            className={`fs-3 me-3 mt-3 text-danger ${req.isAiRequest ? "cursor-not-allowed" : "cursor-pointer"}`}
                          ></MdDelete>
                        </Button>
                      </TableCell>
                    ) : (
                      ""
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell className="text-center" colSpan={8}>
                    No Items Here
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {dataTable.results.length > 0 ? (
            <div className="paginate-box d-flex justify-content-end p-2">
              {home ? (
                ""
              ) : (
                <Box>
                  <FormControl>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={pageSize}
                      label=""
                      onChange={(e) => setPageSize(e.target.value)}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              <button
                disabled={!dataTable.previous}
                className="m-2 border-0 bg-transparent"
                onClick={() => handlePageChange(1)}
              >
                <Tooltip title={`First Page: 1`}>
                  <i className="	fas fa-angle-double-left	"></i>
                </Tooltip>
              </button>
              <button
                onClick={() => handlePageChange(dataTable.page_number - 1)}
                disabled={!dataTable.previous}
                className="m-2 mx-3 border-0 bg-transparent"
              >
                <Tooltip title={`Previous Page: ${dataTable.page_number - 1}`}>
                  <i className="fas fa-chevron-left"></i>
                </Tooltip>
              </button>
              <p className="m-2 mt-3">{`${dataTable.from}-${dataTable.to}  of  ${dataTable.count}`}</p>

              <button
                className="m-2 mx-3 border-0 bg-transparent"
                disabled={!dataTable.next}
                onClick={() => handlePageChange(dataTable.page_number + 1)}
              >
                <Tooltip title={`Next Page: ${dataTable.page_number + 1}`}>
                  <i className="fas fa-chevron-right"></i>
                </Tooltip>
              </button>
              <button
                className="m-2 border-0 bg-transparent"
                disabled={!dataTable.next}
                onClick={() => handlePageChange(dataTable.total_pages)}
              >
                <Tooltip title={`Last Page: ${dataTable.total_pages}`}>
                  <i className="	fas fa-angle-double-right	"></i>
                </Tooltip>
              </button>
            </div>
          ) : (
            ""
          )}
        </TableContainer>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="row">
            <Typography variant="h5" gutterBottom component="div">
              Request Deleting
            </Typography>
            <Divider sx={{ width: "50%", margin: "left" }} />
            <div className="row">
              <div className="col-12 mt-3 text-center">
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  className="mx-2"
                  color="error"
                >
                  Attention... !!
                </Button>
              </div>
              <p className="col-12 lean text-center mt-2">
                Are You Sure To Delete This Request
              </p>

              <div className="col-12 d-flex justify-content-end mt-4">
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  className="mx-2"
                  color="error"
                >
                  Close
                </Button>
                <Button variant="outlined" onClick={handleSubmit}>
                  Delete
                </Button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={paymentModalOpen}
        onClose={handlePaymentClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={paymentModalOpen}>
          <Box sx={style} className="row">
            <Typography variant="h5" gutterBottom component="div">
              Payment Details (Request #{selectedRequestPayment?.id})
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <div className="row">
              <div className="col-12 mb-3">
                <Box sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                  <Typography variant="body1">
                    <strong>Total Cost:</strong> {selectedRequestPayment?.price}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Amount Paid:</strong>{" "}
                    {(selectedRequestPayment?.price || 0) -
                      (selectedRequestPayment?.remaining_amount || 0)}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Remaining Amount:</strong>{" "}
                    {selectedRequestPayment?.remaining_amount}
                  </Typography>
                </Box>
              </div>
              <div className="col-12 mt-2">
                <TextField
                  fullWidth
                  label="Price"
                  variant="outlined"
                  size="small"
                  className="mb-3"
                  disabled={selectedRequestPayment?.isAiRequest}
                  value={newPrice === 0 ? "" : newPrice}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
                      setNewPrice(val === "" ? 0 : val);
                    }
                  }}
                />
              </div>
              <div className="col-12 mt-2">
                <TextField
                  fullWidth
                  label="Special Discount"
                  variant="outlined"
                  size="small"
                  className="mb-3"
                  disabled={selectedRequestPayment?.isAiRequest}
                  value={newDiscount === 0 ? "" : newDiscount}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
                      setNewDiscount(val === "" ? 0 : val);
                    }
                  }}
                />
              </div>

              <Divider sx={{ my: 3 }} />

              <div className="col-12 mb-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <Typography variant="h6" gutterBottom>
                      Partial Payment
                    </Typography>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={partialPaid}
                          disabled={selectedRequestPayment?.isAiRequest}
                          onChange={(e) => setPartialPaid(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Enable Partial Payment"
                    />
                  </div>
                  <div>
                    <Typography variant="h6" gutterBottom>
                      Full Payment
                    </Typography>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isPaid}
                          onChange={handleTogglePaid}
                          color="success"
                        />
                      }
                      label="Mark as Full Paid"
                    />
                  </div>
                </div>
              </div>

              {partialPaid && (
                <div className="col-12 mt-2">
                  <TextField
                    fullWidth
                    label="Paid Amount"
                    variant="outlined"
                    size="small"
                    className="mb-3"
                    type="number"
                    value={paidAmount === 0 ? "" : paidAmount}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
                        setPaidAmount(val === "" ? 0 : parseFloat(val));
                      }
                    }}
                    helperText={`Remaining: ${selectedRequestPayment?.remaining_amount || 0}`}
                  />
                </div>
              )}

              <div className="col-12 d-flex justify-content-between mt-4">
                <Button
                  variant="outlined"
                  onClick={() => downloadInvoice(selectedRequestPayment.id)}
                  color="primary"
                  disabled={selectedRequestPayment?.isAiRequest}
                  style={{
                    opacity: selectedRequestPayment?.isAiRequest ? 0.4 : 1,
                    cursor: selectedRequestPayment?.isAiRequest
                      ? "not-allowed"
                      : "pointer",
                  }}
                >
                  <i className="fas fa-eye me-1"></i> View Invoice
                </Button>
                <div>
                  <Button
                    variant="outlined"
                    onClick={handlePaymentClose}
                    className="mx-2"
                    color="error"
                  >
                    Cancel
                  </Button>
                  {partialPaid ? (
                    <Button
                      variant="contained"
                      onClick={handlePartialPaymentUpdate}
                      color="success"
                    >
                      Update Partial Payment
                    </Button>
                  ) : (
                    <Button variant="contained" onClick={handlePaymentUpdate}>
                      Update Payment
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
      {/* <CustomToastify bgColor={success ? "green" : "red"} duration={false} /> */}
      <ModelStatus
        statusFlag={statusFlag}
        setStatusFlag={setStatusFlag}
        request={request}
        statusId={statusId}
        setStatusId={setStatusId}
        setFlag={setFlag}
        flag={flag}
      />
    </div>
  );
};

export default RequestTracking;
